export default class ErrorMessageService {
    getErrorMessage(errors) {
        let errorMessage = '';

        for (let error in errors) {
            if (errors.hasOwnProperty(error)) {
                errorMessage += errors[error] + ' ';
            }
        }

        return errorMessage;
    }
}
